<template>
  <div id="chartHolder">
    <div id="type-div">
      <div class="type-rect" id="single-div" :class="{'choose-type':type==='single'}" @click="selectType('single')">
        <div class="type-text" :class="{'chooseType':type==='single'}">单 打</div>
      </div>
      <div class="type-rect" id='double-div' :class="{'choose-type':type==='double'}" @click="selectType('double')">
        <div class="type-text" :class="{'chooseType':type==='single'}">双 打</div>
      </div>
      <div class="type-rect" id='mixed-div' :class="{'choose-type':type==='mixed'}" @click="selectType('mixed')">
        <div class="type-text" :class="{'chooseType':type==='single'}">混 双</div>
      </div>
    </div>
    <div id="right">

      <div class="score-compare-select score-compare-select-date" style="margin-left: auto; margin-right: 0;">
        时间：
        <a-date-picker :value="startTime" :locale="locale"
                       @change="(date, dateString) => onChangeDate(dateString, 1)"/>
        &nbsp; <span style="font-weight: 400;">—</span> &nbsp;
        <a-date-picker :value="endTime" :locale="locale"
                       @change="(date, dateString) => onChangeDate(dateString, 2)"/>
      </div>

      <div class="container">
        <div class="bar-div" id="bar-chart-div">
          <svg id="bar-svg" v-if="teamPlayerParData&&teamPlayerParData.length !== 0"
               :width="(singleRectWidth+next)* teamPlayerParData.length+next">
            <line v-for="(line, num) in 5" :key="num+'backline'"
                  :x1="0" :y1="getLineYPosition(num)"
                  :x2="(singleRectWidth + next) * teamPlayerParData.length + next" :y2="getLineYPosition(num)"
                  stroke="#E3E0E0" stroke-opacity="0.5" stroke-width="1">
            </line>
            <g v-for="(teamPlayer,i) in teamPlayerParData" :key="i">
              <text class="player-value" :x="`${(i+1)* next + i*singleRectWidth+singleRectWidth*0.5}`"
                    :y="parseFloat(getSingleRectY(teamPlayer.ptc_count))-3+'px'" font-size="16" text-anchor="middle">
                {{ teamPlayer.ptc_count }}
              </text>
              <rect class="single-bar-rect" :x="`${(i+1)* next + i*singleRectWidth}`"
                    :y="getSingleRectY(teamPlayer.ptc_count)" :width=singleRectWidth
                    :height="getSingleRectHeight(teamPlayer.ptc_count)" :fill="getColor(teamPlayer.ptc_count)"
                    @click="handleClick(teamPlayer)"
                    @mouseover="handleMouseOver(teamPlayer)"
                    @mouseout="handleMouseOut">
              </rect>
              <text v-if="type==='single'" class="player-name"
                    :x="`${(i+1)* next + i*singleRectWidth+singleRectWidth*0.4}`" :y="`28vh`" :dy="`-90px`">
                {{ teamPlayer.player_name }}
              </text>
              <text v-if="type === 'double' || type === 'mixed'" class="player-name"
                    :x="`${(i+1)* next + i*singleRectWidth}`" :y="`28vh`" :dy="`-90px`">
                {{ teamPlayer.player1_name }}
              </text>
              <text v-if="type === 'double' || type === 'mixed'" class="player-name"
                    :x="`${(i+1)* next + i*singleRectWidth+singleRectWidth}`" :y="`28vh`" :dy="`-90px`">
                {{ teamPlayer.player2_name }}
              </text>
            </g>
            <line :x1="0" :y1="getScaleY()" :x2="(singleRectWidth + next) * teamPlayerParData.length + next"
                  :y2="getScaleY()" stroke="#B0ADAD" stroke-width="2">
            </line>

          </svg>
        </div>
      </div>
      <div id="matchInfoTable" v-if="type==='single' && targetPlayer || type==='double' && (targetPlayer && targetPlayerPartner)&& targetPlayer || type==='mixed' && (targetPlayer && targetPlayerPartner)">
        <MatchInfoTable :args="{
              'startTime': startTime,
              'endTime': endTime,
              'team': currentTeam,
              'type_single_double_mixed': type,
              'targetPlayer': targetPlayer,
              'targetPlayerPartner': targetPlayerPartner,
              }"/>
      </div>

    </div>

    <div id="medal">
      <Medal v-if="$store.state.currentTeam!=='foreign_men' && $store.state.currentTeam!=='foreign_women'" :medalList="medal" :teamMedalList="teamMedals" :type="type"/>
<!--      <Medal :medalList="medal" :args="{-->
<!--        'teamMedalList':teamMedals-->
<!--      }" :type="type"/>-->
    </div>
  </div>

</template>

<!--凡是-1的都不可以点击-->
<script>
import * as d3 from "d3";
import {getStatisticParticipation, getTeamMedal, getTeamPlayersAll} from '../api/index';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import MatchInfoTable from '../components/table/MatchInfoTable.vue';
import Medal from '../components/table/Medal.vue';
import {message} from "ant-design-vue";

export default {
  data() {
    return {
      locale,
      teamPlayersAll: [],
      teamPlayerParData: [],
      medal: [],
      teamMedals: [],
      startTime: '2025-01-01',
      endTime: '2025-12-31',
      currentTeam: this.$store.state.currentTeam,
      type: 'single',
      targetPlayer: '',
      targetPlayerPartner: '',
      uniquePtcCount: [],
      singleRectWidth: 23,
      next: 50,
      // dataLoad: false,
      innerHeight: window.innerHeight,
    }
  },
  created() {
    // this.getCurrentTime();
  },
  mounted() {
    // this.getOptions();
    this.receiveTeamPlayersAll()
    // this.init();
    this.medal = []
    // console.log("mount", this.teamPlayerParData);
    window.addEventListener('resize', this.handleWindowResize);
  },
  watch: {
    // startTime: 'update',
    // endTime: 'update',
    // type: 'update',
    // '$store.state.currentTeam'() {
    //   this.currentTeam = this.$store.state.currentTeam;
    //   this.update()
    // },
    // dataLoad: 'init',
    requestParams: {
      handler() {
        if (!this.requestParams.endTime) {
          return;
        }
        this.update();
      },
      immediate: true, // 这是关键！让 watcher 在组件创建后立即执行一次 handler
      deep: true // 如果参数是对象，建议加上
    }
  },
  computed: {
    requestParams() {
      return {
        startTime: this.startTime,
        endTime: this.endTime,
        type: this.type,
        team: this.$store.state.currentTeam
      };
    }
  },
  components: {
    MatchInfoTable,
    Medal,
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    handleWindowResize() {
      this.innerHeight = window.innerHeight;
    },
    getSingleRectY(pct_count) {
      const singleRectHeight = parseFloat(this.getSingleRectHeight(pct_count));
      const pxPerVh = this.innerHeight / 100;
      return pxPerVh * 28 - singleRectHeight - 92 + 'px';
    },
    getSingleRectHeight(pct_count) {
      let maxPtcCount = d3.max(this.teamPlayerParData, (d) => d.ptc_count);
      maxPtcCount = Math.max(maxPtcCount, 5);
      const pxPerVh = this.innerHeight / 100;
      const maxRange = pxPerVh * 26 - 92;
      const yScale = d3.scaleLinear()
          .domain([0, maxPtcCount])
          .range([0, maxRange]);
      if(yScale(pct_count)>0)
      return yScale(pct_count) + 'px';
      else return 0+'px';
    },
    getScaleY() {
      const pxPerVh = this.innerHeight / 100;
      return pxPerVh * 28 - 92 + 'px';
    },
    getLineYPosition(index) {
      const totalLines = 5;
      const startY = parseFloat(this.getScaleY());
      const pxPerVh = this.innerHeight / 100;
      const endY = 2 * pxPerVh;
      const lineGap = (startY - endY) / (totalLines - 1);
      return startY - index * lineGap + 'px';
    },
    getCurrentTime() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      this.endTime = `${year}-${month}-${day}`;
      // console.log("time",this.endTime)
    },
    getOptions() {
      this.$store.commit('setLoading', true)
    },
    async receiveTeamPlayersAll() {
      try {
        const response = await getTeamPlayersAll();
        this.teamPlayersAll = response.data;
        // console.log('后端传来的字典:', this.teamPlayersAll);
      } catch (error) {
        message.error('获取球员名单时发生错误:', error.message, error.response);
      }
    },
    async getTeamCompMedals() {
      try {
        const response = await getTeamMedal(this.$store.state.currentTeam,this.startTime,this.endTime);
        if(response.data.success){
          let res = response.data.data;
          this.teamMedals = [res['gold'],res['silver'],res['bronze']]
        }

      } catch (error) {
        message.error('获取团体奖牌出错:', error.message, error.response);
      }
    },

    async receiveData(startTime, endTime, team, type_single_double_mixed) {
      try {
        if (team) {
          const response = await getStatisticParticipation(startTime, endTime, team, type_single_double_mixed);
          // console.log('后端传来的数据:', response.data);
          return response.data;
        }
      } catch (error) {
        message.error('获取数据时发生错误:', error.message, error.response);
      }
    },
    init() {
      const currentTeam = this.$store.state.currentTeam;
      this.getTeamCompMedals().then(
          ()=>this.receiveData(this.startTime, this.endTime, currentTeam, this.type)
              .then(d => {
                // console.log("init", d)
                this.processData(d);

              })
      )

    },
    processData(d) {
      //将获得的数据进行ptc_count的统计
      // console.log("process", d)
      if (d && d.data && d.data.length > 0) {
        //  type 是 single时统计相同的人的ptc_count
        if (this.type === 'single') {
          //暂时存储处理好的数据
          const processedData = {};
          d.data.forEach(({player_name, ptc_count, medal_number, player_id}) => {
            if (!processedData[player_name]) {
              processedData[player_name] = {
                player_name,
                ptc_count,
                medal_number,
                player_id
              };
            } else {
              processedData[player_name].ptc_count += ptc_count;
              processedData[player_name].medal_number += medal_number;
            }
          });
          //处理好给teamPlayerParData
          const teamPlayerParDataCopy = Object.values(processedData);
          teamPlayerParDataCopy.sort((a, b) => b.ptc_count - a.ptc_count);
          this.teamPlayerParData = teamPlayerParDataCopy;
          this.uniquePtcCount = [...new Set(this.teamPlayerParData.map(item => item.ptc_count))];
        } else if (this.type === 'double' || this.type === 'mixed') {
          const teamPlayerParDataCopy = d.data;
          teamPlayerParDataCopy.sort((a, b) => b.ptc_count - a.ptc_count);
          this.teamPlayerParData = teamPlayerParDataCopy;
          this.uniquePtcCount = [...new Set(this.teamPlayerParData.map(item => item.ptc_count))];
        } else {
          console.warn('特殊的 type 类型:', this.type);
        }
      } else {
        console.warn('数据为空或不完整:', d);
      }
      if (this.teamPlayerParData) {
        if (this.type === 'single') {
          // TODO 这里要试一下如果0是id=-1那么选择下一个，直到俩都不是-1
          for (let i = 0; i < this.teamPlayerParData.length; i++) {
            if (this.teamPlayerParData[i].player_id !== '-1') {
              this.targetPlayer = this.teamPlayerParData[i].player_id;
              break;
            }

          }
        } else if (this.type === 'double' || this.type === 'mixed') {
          for (let i = 0; i < this.teamPlayerParData.length; i++) {
            const currentTeamPlayer=this.teamPlayerParData[i];
            if (currentTeamPlayer.player1_id !== '-1'&&currentTeamPlayer.player2_id !== '-1') {
          this.targetPlayer = currentTeamPlayer.player1_id;
          this.targetPlayerPartner = currentTeamPlayer.player2_id;
              break;
        }
          }}
        // console.log("chushichuan", this.targetPlayer, this.targetPlayerPartner);
      }

      this.processMedalData();
      this.$store.commit('setLoading', false);
    },
    processMedalData() {
      // 初始化奖牌数据
      this.medal = [];
      let medalTypeTotal=[0,0,0];
      // 遍历数据数组
      for (let i = 0; i < 3; i++) {
        let detail = [];
        let perTypeTotal=0;
        this.teamPlayerParData?.forEach((item) => {
          if (item.medal_number[i] !== 0) {
            if (this.type === 'single') {
              detail.push({
                player_name: item.player_name,
                medal_number: item.medal_number[i]
              });
              perTypeTotal+=item.medal_number[i];
              medalTypeTotal[i]=perTypeTotal;
            } else if (this.type === 'double' || this.type === 'mixed') {
              detail.push({
                player1_name: item.player1_name,
                player2_name: item.player2_name,
                medal_number: item.medal_number[i]
              });
              perTypeTotal+=item.medal_number[i];
              medalTypeTotal[i]=perTypeTotal;
            }
          }
        })
        this.medal[i] = detail;

      }
      this.medal[3] = medalTypeTotal;
    },
    /*createBarChart() {
      // 清空 SVG
      d3.select("#bar-svg").selectAll("*").remove();
      if(this.type==='single'){
        this.targetPlayer=this.teamPlayerParData[0].player_id;}
      else if (this.type === 'double' || this.type === 'mixed') {
        this.targetPlayer=this.teamPlayerParData[0].player1_id;
        this.targetPlayerPartner=this.teamPlayerParData[0].player2_id;}
      console.log("chushichuan",this.targetPlayer,this.targetPlayerPartner);

      const barSvg = d3
          .select("#bar-svg");
      const container=d3.select(".container")
      const barDiv = container.select(".bar-div");
      var barChartHtml=document.getElementById('bar-chart-div');
      var barChartHeight=barChartHtml.clientHeight;
      let maxPtcCount= d3.max(this.teamPlayerParData, (d) => d.ptc_count);
      maxPtcCount = Math.max(maxPtcCount, 5);
      const singleWidth = 23;
      const next = 50;
      const chartWidth =(singleWidth+next)* this.teamPlayerParData.length+next;
      const barRectHeight=barChartHeight*0.75;
      // const valueHeight=containerHeight*0.07;
      const nameHeight=barChartHeight*0.18;
      //console.log("max",maxPtcCount);
      barSvg.attr("width",chartWidth);
      const yScale = d3.scaleLinear()
          .domain([0, maxPtcCount])
          .range([0, barRectHeight]);
      // 标记坐标轴横线
      barSvg
          .append("line")
          .attr("x1", 0)
          .attr("y1", barChartHeight-nameHeight)
          .attr("x2", chartWidth)
          .attr("y2", barChartHeight-nameHeight)
          .attr("stroke", "#B0ADAD")
          .attr("stroke-width", 2);
      //标记横线
      for (let i = barChartHeight-nameHeight; i >0; i= i-barRectHeight*0.2) {
        barSvg
            .append("line")
            .attr("x1", 0)
            .attr("y1", i)
            .attr("x2", chartWidth)
            .attr("y2", i)
            .attr("stroke", "#E3E0E0")
            .attr("stroke-opacity", 0.5)
            .attr("stroke-width", 1);
      }
      // 创建柱状图
      barSvg.selectAll("rect")
          .data(this.teamPlayerParData)
          .enter()
          .append("rect")
          .attr("x", (d, i) => (i+1)* next + i*singleWidth)
          .attr("y", (d) => barChartHeight-nameHeight - yScale(d.ptc_count))
          .attr("width", singleWidth)
          .attr("height", (d) => yScale(d.ptc_count))
          .attr("fill", (d) => this.getColor(d.ptc_count))
          .on("click", (event, d) => {
            console.log("Clicked:", 1);
            // 调用 sendData 方法，传递给子组件
            this.sendDataToMatchInfoTable(d);})
          .on("mouseover", function() {
            d3.select(this).style("cursor", "pointer")
          })
          .on("mouseout", function() {
            d3.select(this).style("cursor", "default");
          });
      //标记名字
      const playerName=barSvg
          .selectAll("text.letter")
          .data(this.teamPlayerParData)
          .enter()
      if(this.type==='single'){
        playerName.append("text")
            .attr("class", "player_name")
            .attr("text-anchor", "middle")
            .attr("y", barChartHeight-nameHeight)
            .attr("x", (d, i) => (i+1)* next +(i+0.5)*singleWidth)
            .text((d) => d.player_name);
      }
      else if (this.type === 'double' || this.type === 'mixed') {
        playerName.append("text")
            .attr("class", "player_name")
            .attr("text-anchor", "middle")
            .attr("y", barChartHeight-nameHeight)
            .attr("x", (d, i) => (i+1)* next +i*singleWidth)
            .text((d) => d.player1_name);
        playerName.append("text")
            .attr("class", "player_name")
            .attr("text-anchor", "middle")
            .attr("y", barChartHeight-nameHeight)
            .attr("x", (d, i) => (i+1)* next +(i+1)*singleWidth)
            .text((d) => d.player2_name);
      }
      //标记数值
      barSvg
          .selectAll("text.value")
          .data(this.teamPlayerParData)
          .enter()
          .append("text")
          .attr("class", "ptc_count")
          .attr("x", (d, i) => (i+1)* next +(i+0.5)*singleWidth)
          .attr("y", (d) => barChartHeight-nameHeight- yScale(d.ptc_count) - 5)
          .text((d) => d.ptc_count)
          .attr("text-anchor", "middle");
      if (chartWidth <1598) {
        barDiv.style("width", `${chartWidth}px`);
      }

      if (chartWidth > 1598) {
        barDiv.style("width", `${chartWidth}px`);
        // barSvg.style("width",`${chartWidth}px`)
        // barSvg.selectAll('line').style("x2",`${chartWidth}px`)
      }

    },*/
    getColor(value) {
      if (value === this.uniquePtcCount[0]) {
        return "orange";
      } else if (value === this.uniquePtcCount[1]) {
        return "#5B9BD5";
      } else if (value === this.uniquePtcCount[2]) {
        return "gray";
      } else {
        return "lightgray"
      }
    },
    handleClick(teamPlayer) {
      // console.log("Clicked:", teamPlayer);
      if(teamPlayer['player1_id']!=='-1' && teamPlayer['player2_id']!=='-1' ){
        // 调用 sendData 方法，传递给子组件
        this.sendDataToMatchInfoTable(teamPlayer);
      }else{
        message.error('此球员不在数据库中，请完善数据库',teamPlayer['player1_id']==='-1'?(teamPlayer['player2_id']==='-1'?teamPlayer['player1_name']+teamPlayer['player2_name']:teamPlayer['player1_name']):teamPlayer['player2_name'])
      }

    },
    handleMouseOver(teamPlayer) {
      if(teamPlayer['player1_id']!=='-1' && teamPlayer['player2_id']!=='-1' ){
        d3.select(this.$el).style("cursor", "pointer");
      }else{
        d3.select(this.$el).style("cursor", "not-allowed");
      }
    },
    handleMouseOut() {
      d3.select(this.$el).style("cursor", "default");
    },
    sendDataToMatchInfoTable(data) {
      if (this.type === 'single') {
        this.targetPlayer = data.player_id;
      } else if (this.type === 'double' || this.type === 'mixed') {
        this.targetPlayer = data.player1_id;
        this.targetPlayerPartner = data.player2_id;
      }
      // console.log("clickchuan", this.targetPlayer, this.targetPlayerPartner)
    },
    update() {
      this.teamPlayerParData = null;
      this.targetPlayer = '';
      this.targetPlayerPartner = '';
      this.getOptions();
      this.init();
    },
    selectType(newType) {
      if (this.type === newType) return; // 防止重复点击当前 tab 发起请求
      this.type = newType;
    },
    onChangeDate(dateString, index) {
      if (index === 1) {
        this.startTime = dateString;
      } else {
        this.endTime = dateString;
      }
    },
  },

}
</script>

<style>
#chartHolder {
  padding-top: 2vh;
  height: calc(100vh - 66px);
  margin-left: 30px;
  margin-right: 30px;
}

#type-div {
  position: absolute;
  margin-left: 2vw;
  width: 65px;
  height: calc(97vh - 66px);
  display: flex;
  flex-direction: column;
}

.type-rect {
  flex: 1;
  border: 1px solid #00375b;
  width: 65px;
  fill: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.type-text {
  font-size: 20px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  font-family: Microsoft YaHei;
  text-align: center;
}

.choose-type {
  font-weight: bold;
  border-width: 3px;
}

#right {
  position: relative;
  left: calc(5vw + 20px);
  width: calc(97vw - 145px);
  height: calc(97vh - 66px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.container {
  position: relative;
  margin-left: 2%;
  max-width: calc(97vw - 145px);
  height: 29vh;
  overflow-y: hidden;
  overflow-x: auto;
}

.bar-div {
  position: relative;
  display: inline-block;
  height: 29vh;
  margin-left: 0;
  left: 0;
}

#bar-svg {
  position: relative;
  height: 29vh;
  margin-left: 0;
  left: 0;
}

.player-name {
  writing-mode: vertical-rl;
  font-size: 16px;
}

#medal {
  position: absolute;
  left: auto;
  right:20px;
  top: 8vh;
  width: 300px;
  height: 250px;
}

.single-bar-rect {

}

#matchInfoTable {
  position: relative;
  height: 60%;
  width: calc(97vw - 145px);
}
</style>
